<template>
    <div id="schritt-3">
        <b-row class="cc-point-title-container mt-2">
            <b-col class="col-2 pt-1"><img src="../assets/mobileline.png"></b-col>
            <b-col class="col-8"><h3 id="cost"  class="cc-point-title">Schritt 3 - Technische Anforderungen</h3></b-col>
            <b-col class="col-2 pt-1"></b-col>
        </b-row>

        <div class="page-paddings">
            <div class="cc-questions-container">

                <div class="point-container">
                    <div class="row mt-3">
                        <p class="point-number">10. </p>
                        <p class="point-name"> Auf welchen Plattformen soll Ihre App erscheinen?</p>
                    </div>

                    <div class="col">
                        <b-form-checkbox-group
                                v-model="selection3.selected10"
                                :options="options10"
                                class="mb-3 input-pad-big"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-checkbox-group>

                    </div>
                </div>

                <div class="point-container">
                    <div class="row">
                        <p class="point-number">11. </p>
                        <p class="point-name"> Auf welchen Endgeräten soll Ihre App erscheinen?</p>
                    </div>

                    <div class="col">
                        <b-form-checkbox-group
                                v-model="selection3.selected11"
                                :options="options11"
                                class="mb-3 input-pad-big"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-checkbox-group>

                    </div>
                </div>

                <div class="point-container">
                    <div class="row">
                        <p class="point-number">12. </p>
                        <p class="point-name">In wie vielen Sprachen soll Ihre App erscheinen?</p>
                    </div>

                    <div class="col">
                        <b-form-radio-group
                                v-model="selection3.selected12"
                                :options="options12"
                                class="mb-3 input-pad-big"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-radio-group>
                    </div>
                </div>

                <div class="point-container">
                    <div class="point-container">
                        <div class="row">
                            <p class="point-number">13. </p>
                            <p class="point-name"> Offline-Funktionsfähigkeit:</p>
                        </div>

                        <div class="col">
                            <b-form-radio-group
                                    v-model="selection3.selected13"
                                    :options="options13"
                                    class="mb-3 input-pad-big"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                            ></b-form-radio-group>

                        </div>
                    </div>

                    <div class="point-container">
                        <div class="row">
                            <p class="point-number">14. </p>
                            <p class="point-name"> Genutzte Hardware-Funktionen:</p>
                        </div>

                        <div>
                            <b-form-checkbox-group
                                    v-model="selection3.selected14"
                                    :options="options14"
                                    class="mb-3 d-grid-40"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                            ></b-form-checkbox-group>
                        </div>
                    </div>

                    <div class="point-container">
                        <div class="row">
                            <p class="point-number">15. </p>
                            <p class="point-name"> Eigenständige Content-Verwaltung:</p>
                        </div>

                        <div class="col">
                            <b-form-radio-group
                                    v-model="selection3.selected15"
                                    :options="options15"
                                    class="mb-3 input-pad-big"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                            ></b-form-radio-group>
                        </div>
                    </div>
                    <b-row>
                        <b-row class="text-right amount-row">
                            <b-col class="col-5"><p class="amount-text mt-3 text-right">Kosten - Schritt 3</p></b-col>
                            <b-col class="col-7"><b-button class="amount-button pl-1  ml-1 text-center">€ {{get3cost}}  </b-button></b-col>
                        </b-row>
                    </b-row>
                </div>
            </div>
        </div>

        <b-row class="entry-part-end text-center">
            <b-col class="mx-auto pb-3" cols="12"><b-button  @click="prevStep" class="mx-auto cc-button text-center mx-auto">Back</b-button></b-col>
            <b-col class="mx-auto mt-3 pt-3" cols="12"><b-button  href="#" v-scroll-to="'#element'" class="mx-auto cc-button text-center">Preis herausfinden</b-button></b-col>
        </b-row>

        <!--final count-->
        <div>
            <div class="">
                <b-row id="element" class="cc-point-title-container mb-5">
                    <b-col class="col-lg-8"><h3  class="cc-point-title-final">Wie viel kostet eine App? </h3></b-col>
                </b-row>

                <b-row class="pt-2">
                    <b-col class="col-6"><p class="semi-final-amount">Allgemeine Informationen </p></b-col>
                    <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€ {{ Cost1}} </p></b-col>
                    <b-col class="col-12"><hr class="w-100 hr-semi-final"></b-col>
                </b-row>


                <b-row class="pt-2">
                    <b-col class="col-6"><p class="semi-final-amount">Marketing und Vertrieb </p></b-col>
                    <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€  {{ Cost2}} </p></b-col>
                    <b-col class="col-12"><hr class="w-100 hr-semi-final"></b-col>
                </b-row>

                <b-row class="pt-2">
                    <b-col class="col-6"><p class="semi-final-amount">Technische Anforderungen </p></b-col>
                    <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€  {{get3cost}} </p></b-col>
                    <b-col class="col-12"><hr class="w-100 hr-semi-final"></b-col>
                </b-row>

                <b-row class="pt-2 mb-5">
                    <b-col class="col-8"><h2 class="cc-point-title-final">Gesamtkosten</h2></b-col>
                    <b-col class="col-4"><h2 class="cc-point-title-final text-right">€ {{ Cost1 + Cost2 + get3cost }}</h2></b-col>

                </b-row>



                <!--        footer elements-->


            </div>


        </div>


    </div>


</template>
<script>

    export default {
        data() {
            return {

                Cost1: '',
                Cost2: '',
                Cost3: '',
                text1: '',
                text2: '',
                formatter: '',
                // total1: 0,
                total2: 0,
                total3: 0,
                value: 0,
                selection3: {
                    selected10: '',
                    selected11: '',
                    selected12: '',
                    selected13: '',
                    selected14: '',
                    selected15: '',
                },
                result1: '',
                options10: [
                    { item: 'A', name: 'iOS' },
                    { item: 'B', name: 'Android' },
                    { item: 'C', name: 'Web' },
                ],
                options11: [
                    { item: 'A', name: 'Smartphones' },
                    { item: 'B', name: 'Tablets' },
                    { item: 'C', name: 'Desktop' },
                ],
                options12: [
                    { item: 'A', name: '1' },
                    { item: 'B', name: '2' },
                    { item: 'C', name: '3' },
                    { item: 'D', name: '4' },
                    { item: 'E', name: '> 5' }
                ],
                options13: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ],
                options14: [
                    { item: 'A', name: 'GPS' },
                    { item: 'B', name: 'Mikrofon' },
                    { item: 'C', name: 'NFC' },
                    { item: 'D', name: 'Kamera' },
                    { item: 'E', name: 'Bluetooth' },
                    { item: 'F', name: 'Gyroskop-Sensor' },
                    { item: 'G', name: 'Fingerabdrucksensor' },
                    { item: 'H', name: 'Gesichtserkennung' },
                    { item: 'I', name: 'Beschleunigungsmesser' },
                    { item: 'K', name: 'Näherungssensor' },
                    { item: 'L', name: 'Lichtsensor' },
                    { item: 'M', name: 'Schrittmesser' },
                    { item: 'N', name: 'Pulsmesser' },
                    { item: 'O', name: 'Magnetomesser (digitaler Kompass)' }
                ],
                options15: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ]
            }
        },
        mounted() {
            if ('selection3' in localStorage) {
                this.selection3 = localStorage.getItem('selection3') !== 'undefined' ?
                    JSON.parse(localStorage.getItem('selection3')) : {
                        selected10: '',
                        selected11: '',
                        selected12: '',
                        selected13: '',
                        selected14: '',
                        selected15: '',
                    };
            }

            this.Cost1 = parseInt(localStorage.getItem('get1cost'));
            this.Cost2 = parseInt(localStorage.getItem('get2cost'));
            this.Cost3 = parseInt(localStorage.getItem('get3cost'));
        },
        computed: {
            get3cost () {
                // let total1 = 1;
                let total10 = 1;
                let total11 = 1;
                let total12 = 0;
                let total13 = 0;
                let total14 = 0;
                let total15 = 0;
                let total141 = 1;
                let total142 = 1;
                let total143 = 1;
                let total144 = 1;
                let total145 = 1;
                let total146 = 1;
                let total147 = 1;
                let total148 = 1;
                let total149 = 1;
                let total1410 = 1;
                let total1411 = 1;
                let total1412 = 1;
                let total1413 = 1;
                let total1414 = 1;


                if (this.selected1 === 'A') {
                    localStorage.setItem('total1', 1.5);
                } else if ( this.selected1 === 'B') {
                    localStorage.setItem('total1', 1);
                } else if ( this.selected1 === 'C') {
                    localStorage.setItem('total1', 0.8);
                } else if ( this.selected1 === 'D') {
                    localStorage.setItem('total1', 0.5);
                }


                if (this.selection3.selected10.length === 1 ){
                    total10 = 1;
                }
                if (this.selection3.selected10.length > 1 ){
                    total10 = 1.5;
                }



                if (this.selection3.selected11.length === 1 ){
                    total11 = 1;
                }
                if (this.selection3.selected11.length > 1 ){
                    total11 = 1.2;
                }


                if (this.selection3.selected12 === 'A') {
                    total12 = 0;
                } else if ( this.selection3.selected12 === 'B') {
                    total12 = 1;
                } else if ( this.selection3.selected12 === 'C') {
                    total12 = 2;
                } else if ( this.selection3.selected12 === 'D') {
                    total12 = 2;
                } else if ( this.selection3.selected12 === 'E') {
                    total11 = 3;
                }




                if (this.selection3.selected13 === 'A') {
                    total13 = 0;
                } else if ( this.selection3.selected13 === 'B') {
                    total13 = 2;
                }

                if (this.selection3.selected14.includes('A') ){
                    total141 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'B') ){
                    total142 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'C') ){
                    total143 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'D') ){
                    total144 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'E') ){
                    total145 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'F') ){
                    total146 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'G') ){
                    total147 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'H') ){
                    total148 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'I') ){
                    total149 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'K') ){
                    total1410 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'L') ){
                    total1411 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'M') ){
                    total1412 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'N') ){
                    total1413 = 1.1;
                }
                if ( this.selection3.selected14.includes( 'O') ){
                    total1414 = 1.1;
                }
                this.selection3.selected14 ? total14 =  total141 * total142 * total143 * total144 * total145 * total146 * total147 * total148 * total149 * total1410 * total1411 * total1412 * total1413 * total1414 : 0;

                if (this.selection3.selected15 === 'A') {
                    total15 = 4;
                } else if ( this.selection3.selected15 === 'B') {
                    total15 = 0;
                }

                let get3cost = this.isZero(localStorage.getItem('total1')) * (1500 * (this.isZero(total12 + total13 + total14)) * this.isZero(total10) * this.isZero(total11) + 1500 * total15);
                localStorage.setItem('get3cost', get3cost)

                return Math.round(get3cost);
            },

        },
        methods: {
            prevStep() {
                localStorage.setItem('selection3', JSON.stringify(this.selection3));
                this.$router.push(
                    {
                        name: 'Schritt2'
                    }
                )
            },
            changeCalView (){
                if ( this.selected3 === 'B') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log(document.getElementById('b2b'))
                } else if (this.selected3 === 'C') {
                    document.getElementById('b2c2').classList.add("clickedb2b");
                    document.getElementById('b2b2').classList.remove("clickedb2b");
                    console.log('C')
                } else if (this.selected3 === 'A') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log('A')
                }
            },
            isZero(value) {
                if (value === 0) {
                    return 1
                }
                return value;
            }
        }
    }
</script>